import { Box, Button, Container, Divider, Paper, Stack, Typography, useTheme, Grid } from '@mui/material';
import TermsCheckbox from '../../../components/TermsCheckbox';
import AnimationPage from '../../AnimationPage';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import { FormInputText } from '../../../form-components/FormInputText';
import { useForm } from 'react-hook-form';

const initialTermsAll = {
  term1: true,
  term2: true,
  term3: true,
};

const initialTerms = {
  term1: false,
  term2: false,
  term3: false,
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '800px',
  maxHeight: '800px',
  bgcolor: 'background.paper',
  border: '2px solid #0F7F85',
  padding: '20px',
  boxShadow: 24,
  p: 4,
  overflow: 'auto',
};

const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s])[^\s]{8,16}$/;

const EmailResponsePassword = ({ data, setData, setNext }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const [terms, setTerms] = useState(initialTerms);
  const [all, setAll] = useState(false);
  const [termNumber, setTermNumber] = useState(null);

  const {
    control,
    reset,
    handleSubmit,
    setError,
    watch,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: '',
      verifyPassword: '',
    },
  });

  useEffect(() => {
    if (passwordRegex.test(watch('password'))) {
      clearErrors('password');
      if (watch('password') !== watch('verifyPassword')) {
        return setError('verifyPassword', {
          type: 'custom',
          message: '* 입력한 비밀번호와 일치하지 않습니다.',
        });
      } else {
        clearErrors('verifyPassword');
        setNext(false);
        setData({ ...data, password: watch('password') });
      }
    } else {
      return setError('password', {
        type: 'manual',
        message: '* 비밀번호가 올바르지 않습니다.',
      });
    }
  }, [watch('password'), watch('verifyPassword')]);

  useEffect(() => {
    reset({
      password: '',
      verifyPassword: '',
    });
    setNext(true);
  }, []);

  const password = watch('password');
  return (
    <Box sx={{ display: 'flex', mt: 4 }}>
      <Box sx={{ m: 'auto' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '670px',
            maxHeight: '160px',
            background: '#F5F5F5',
            padding: '60px 120px',
            borderRadius: '16px',
            color: '#111111',
          }}>
          <Stack ml="6px">
            <Typography sx={{ fontWeight: '400', fontSize: '17px', textAlign: 'center', mb: '5px' }}>
              회원님의 아이디는
            </Typography>
            <Typography sx={{ fontWeight: 'bold', fontSize: '17px', textAlign: 'center' }}>{data?.username}</Typography>
            <Typography sx={{ fontWeight: '400', fontSize: '17px', textAlign: 'center' }}>입니다.</Typography>
          </Stack>
        </Box>
        <Box style={{ height: '140px', width: '100%' }}>
          <Grid container sx={{ justifyContent: 'space-between', maxWidth: '484px', margin: 'auto', height: '140px' }}>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', my: 3.25 }}>
                <Grid item xs={2}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>비밀번호</Typography>
                </Grid>
                <Grid item xs={10}>
                  <FormInputText
                    className="input-large"
                    name="password"
                    control={control}
                    rules={{
                      required: '비밀번호는 필수 항목입니다.',
                      pattern: {
                        value: passwordRegex,
                        message: '8~16자 영문, 숫자 포함',
                      },
                    }}
                    type="password"
                    placeholder="비밀번호를 입력해 주세요(8자 이상 영문,숫자,특수문자 포함)"
                    error={!!errors.password}
                    helperText={errors?.password?.message}
                  />
                </Grid>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', mt: 3.25 }}>
                <Grid item xs={2}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>비밀번호 확인</Typography>
                </Grid>
                <Grid item xs={10}>
                  <FormInputText
                    className="input-large"
                    name="verifyPassword"
                    control={control}
                    rules={{
                      required: '비밀번호 확인은 필수 항목입니다.',
                      validate: value => value === password || '비밀번호가 일치하지 않습니다.',
                    }}
                    type="password"
                    placeholder="비밀번호를 입력해 주세요(8자 이상 영문,숫자,특수문자 포함)"
                    error={!!errors.verifyPassword}
                    helperText={errors?.verifyPassword?.message}
                  />
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default EmailResponsePassword;
